import React from 'react';
import './index.css';
import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import App from './App';
import ThankYou from './ThankYou';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import PrivacyPolicy from './PrivacyPolicy';


const root = ReactDOM.createRoot(document.getElementById('root'));
let routers = createBrowserRouter([
  {
    path: '/',
    element: <App />
  },
  {
    path: 'thank-You',
    element: <ThankYou />
  },
  {
    path: 'privacy-policy',
    element: <PrivacyPolicy />
  }
])
root.render(
  <React.StrictMode>
    <RouterProvider router={routers} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
